"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _getTransformers = _interopRequireDefault(require("./utils/getTransformers"));

var _parseConfig = _interopRequireDefault(require("./utils/parseConfig"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configUtils = {
  getMapConfigResponse: function getMapConfigResponse(config) {
    this.transformers = _getTransformers.default.get(config); // eslint-disable-next-line no-underscore-dangle

    return this._mapConfigResponse.bind(this);
  },
  _mapConfigResponse: function mapConfigResponse(commands, rawData) {
    var _this = this;

    var experimentOverrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var blacklistConfigOverride = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var response = {};

    if (!commands || !rawData) {
      return response;
    }

    var parsedData = (0, _parseConfig.default)(commands, rawData);
    (0, _forEach.default)(parsedData, function (obj, key) {
      var transformMethod = _this.transformers[key];
      response[key] = transformMethod ? transformMethod(obj, experimentOverrides, blacklistConfigOverride) : obj;
    }); // caching experiment overrides for later use (i.e., when refetching config on client)

    response.experimentOverrides = experimentOverrides;
    return response;
  }
};
var _default = configUtils;
exports.default = _default;